"use strict";

import {loadParsley} from "@elements/parsley-bootstrap-validation";

export function init () {
    let $addFormSection = $('.js-add-form-section');
    let $deliverySameAddress = $('.js-add-form-section__checkbox');
    let $countrySelect = $('.js-add-form-section__country');

    $(document).ready(function() {
        try {
            if(sessionStorage.getItem('countrySelectDelivery') === sessionStorage.getItem('countrySelect')){
                $($addFormSection.data('target')).addClass('hide');
                $deliverySameAddress.prop( 'checked', true );
                $(this).attr('data-show-delivery-form', false);
            }
            $countrySelect.trigger('change');
        }catch (e) {
            console.log(e);
        }
    })

    $addFormSection.on('click', function () {
        let $target = $($(this).data('target'));

        $deliverySameAddress.prop( 'checked', false );

        $(this).addClass('hide');
        $target.removeClass('hide');
    });

    $deliverySameAddress.on('change', function () {

        loadParsley().then(function() {
            $deliverySameAddress.closest('form').parsley().refresh();
        });

        if(!$(this).is(":checked")){
            $($addFormSection.data('target')).removeClass('hide');
            $(this).attr('data-show-delivery-form', true);
            $countrySelect.trigger('country-changed', $('.js-checkout-country__delivery-country').val());
            sessionStorage.setItem('countrySelectDelivery', $('.js-checkout-country__delivery-country').val())
        }else{
            $addFormSection.addClass('hide');
            $($addFormSection.data('target')).addClass('hide');
            $(this).attr('data-show-delivery-form', false);
            $countrySelect.trigger('country-changed', sessionStorage.getItem('countrySelect'));
            sessionStorage.setItem('countrySelectDelivery', sessionStorage.getItem('countrySelect'))
        }
    });
    
    //check if county can be a delivery country, if not delivery form gets shown

    $countrySelect.on('change', function () {
        let country = $countrySelect.val();

        let $deliverySelectOptions = $('.js-checkout-country__delivery-country option');
        let options = [];
        $deliverySelectOptions.map(function(){
            options.push(this.value);
        });

        if(options.indexOf(country) !== -1){
            $deliverySameAddress.attr('disabled', false);
        }
        else{
            $deliverySameAddress.prop('checked', false);
            $deliverySameAddress.attr('disabled', true);
            $deliverySameAddress.trigger('change');
        }
    });
}
